import { ICadImportAction, ICadImportState } from './cadImport.types'
import { CadImportConstants } from './cadImport.constants'

export const initialCadImportState: ICadImportState = {
  isLoading: false,
  success: false,
  failure: false,
  responseMessage: '',
  importedCadRecordId: null,
  importedCadData: [],
  importResponse: {},
  importSuccess: false,
  disableUnitFilteringFlag: false,
  userCanDisableUnitFilter: false,
  hasImportedCadData: false,
}

export function cadImportReducer(
  state: ICadImportState = initialCadImportState,
  action: ICadImportAction
): ICadImportState {
  switch (action.type) {
    case CadImportConstants.GET_CAD_RECORDS:
      return { ...state, isLoading: true }
    case CadImportConstants.SET_CAD_RECORDS_RESPONSE:
      return {
        ...state,
        ...action.cadImport,
        isLoading: false,
      }
    case CadImportConstants.RESET_STATE:
      return {
        isLoading: false,
        success: false,
        failure: false,
        responseMessage: '',
        importedCadRecordId: null,
        importedCadData: [],
        importResponse: {},
        importSuccess: false,
        disableUnitFilteringFlag: false,
        userCanDisableUnitFilter: false,
        hasImportedCadData: false,
      }
    case CadImportConstants.IMPORT_CAD_DATA:
    case CadImportConstants.PRE_CAD_IMPORT:
      return { ...state, importedCadData: action.importedCadData }
    case CadImportConstants.SET_SAVE_CAD_DATA_RESPONSE:
      return { ...state, importResponse: action.importResponse, importSuccess: action.importResponse ? true : false }
    case CadImportConstants.SET_DISABLE_UNIT_FILTERING_FLAG:
      return { ...state, disableUnitFilteringFlag: action.disableUnitFilteringFlag }
    case CadImportConstants.SET_USER_CAN_DISABLE_UNIT_FILTER:
      return { ...state, userCanDisableUnitFilter: action.userCanDisableUnitFilter }
    case CadImportConstants.HAS_IMPORTED_CAD_DATA:
      return { ...state, hasImportedCadData: action.hasImportedCadData }
    case CadImportConstants.REMOVE_IMPORTED_CAD_DATA_POINT:
      return {
        ...state,
        importedCadData: state.importedCadData.filter((dataPoint) => dataPoint.id !== action.dataPointId),
      }
    default:
      return state
  }
}
